import React from 'react'
import AboutPage from './AboutPage';
import ProjectsPage from './ProjectsPage';
import ContactPage from './ContactPage';
import Header from '../components/Header'
const HomePage = () => {
    return (
        <div>
            <Header />
            <AboutPage ></AboutPage>
            <ProjectsPage></ProjectsPage>
            <ContactPage></ContactPage>
        </div>
    );
}

export default HomePage;